import { EventBus } from '@utils/EventBus'
import api from '@/api/Api'

let subscribedChannels = []

export const state = {
  taskData: [],
  taskEvent: new EventBus(),
  status: true,
  noData: true,
  currentTask: null
}

export const getters = {
  taskData (state) {
    return state.taskData
  },
  status (state) {
    return state.status
  },
  noData (state) {
    return state.noData
  }
}

export const mutations = {
  SET_TASK (state, newValue) {
    state.taskData = newValue
    state.taskEvent.$emit('taskChange', newValue)
  },
  UPDATE_STATUS (state, newStatus) {
    state.status = newStatus
  },
  UPDATE_NODATA (state, noData) {
    state.noData = noData
  },
  SET_CURRENT_TASK (state, newValue) {
    state.currentTask = newValue
  }
}

export const actions = {
  fetchTask ({ commit, dispatch, state }, task) {
    return api.getTrainingReport(task.id).then((response) => {
      if ((task.status.isSuccess || task.status.isError) && !response.data.data.length) {
        commit('UPDATE_STATUS', false)
        commit('UPDATE_NODATA', true)
      } else {
        commit('UPDATE_STATUS', true)
        commit('UPDATE_NODATA', false)
      }
      commit('SET_TASK', response.data.data)
      dispatch('initListen', task)
    })
  },
  fetchTaskV2 ({ commit, dispatch, state }, { task, training }) {
    return api.getTrainingV2(training.workspace_id, training.id, {}).then((response) => {
      const training = response.data.data
      const process = training.processes.find(p => p.training_task_id === task.id)
      const epochs = (process.epochs || []).map(e => ({
        task_id: task.id,
        epoch: e.id,
        id: e.id,
        payload: e.payload
      }))
      if ((task.status.isSuccess || task.status.isError) && !epochs.length) {
        commit('UPDATE_STATUS', false)
        commit('UPDATE_NODATA', true)
      } else {
        commit('UPDATE_STATUS', true)
        commit('UPDATE_NODATA', false)
      }
      commit('SET_TASK', epochs)
      dispatch('initListen', task)
    })
  },
  initListen ({ commit, state, dispatch }, task) {
    let channel = window.Echo.private(`training.${task.id}`)
      .listen('TrainingStatusChange', (e) => {
        if (e.is_done) {
          commit('UPDATE_STATUS', false)
          commit('UPDATE_NODATA', false)
          channel.unsubscribe()
          let index = subscribedChannels.indexOf(channel)
          if (index > -1) {
            subscribedChannels.splice(index, 1)
          }
        } else {
          if (state.currentTask.id === e.task_id) {
            commit('SET_TASK', e.data)
          }
        }
      })
    subscribedChannels.push(channel)
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/tensorBoard.js